import { PaletteOptions } from '@mui/material';
import { hexToRGBA } from '../utils';

const MuiPalette: PaletteOptions = {
  primary: { main: '#EDA30E' },
  secondary: { main: '#333333' },
  info: { main: '#FFFFFF' },
  background: {
    default: '#181818',
    paper: '#222222',
  },
  text: {
    primary: '#FFFFFF',
    secondary: hexToRGBA('#FFFFFF', 0.5),
  },
  divider: '#474747',
};

const Project_Specific_Palette = {
  PrimaryButton: '#FFD100',
  Status: {
    Success: '#00FF59',
    Pending: '#32A3FF',
    Reject: '#FF3C00'
  }
}

// For chart Component
const _PALETTE = {
  ChartColor1: '#8a64ff',
  ChartColor2: '#00F5FF',
  ChartColor3: '#5700D4',
  ChartColor4: '#005FF5',
  ChartColor5: '#63FFBE',
  ChartColor6: '#AFDA75',

  DashBoardColor1: '#20D3FD',
  GreyColor: '#B0B0B0',
  DotColor: '#448DDD',
};

const COLOR_THEME = {
  CustomSx: {
    Chart: {
      DoughnutChart: {
        ChartColor: [
          _PALETTE.ChartColor1,
          _PALETTE.ChartColor2,
          _PALETTE.ChartColor3,
          _PALETTE.ChartColor4,
          _PALETTE.ChartColor5,
          _PALETTE.ChartColor6,
        ],
      },
      LineChart: {
        LineColor: _PALETTE.DashBoardColor1,
        CartesianGridColor: _PALETTE.GreyColor,
        DotColor: _PALETTE.DotColor,
      },
    },
  },
};

export { COLOR_THEME, MuiPalette, Project_Specific_Palette };
